import React from 'react';
import withSortedPageRows from '../hoc/withSortedPageRows';
import TableRow from './TableRow';

class Body extends React.Component {
  render() {
    const {
      pageRows,
      head,
      isFixedSize,
      highlightedRowIndex,
      testId
    } = this.props;
    return /*#__PURE__*/React.createElement("tbody", {
      "data-testid": testId && `${testId}--body`
    }, pageRows.map((row, rowIndex) => /*#__PURE__*/React.createElement(TableRow, {
      head: head,
      isFixedSize: isFixedSize,
      key: row.key || rowIndex,
      row: row,
      isHighlighted: highlightedRowIndex === rowIndex,
      testId: testId
    })));
  }

}

export default withSortedPageRows(Body);